/**
 * Menu Content — Huqup Cafe & Grill, Little Elm TX
 *
 * Complete menu data extracted from the official Huqup menu.
 * SEO-optimized descriptions for Mediterranean, Middle Eastern,
 * hookah, kebabs, mezze, artisan pizzas, and specialty drinks.
 */

const menuContent = {
  /* ──── Delicious Menu (Home Page Tabbed Section) ──── */
  deliciousMenu: {
    subtitle: 'from our kitchen',
    title: 'Delicious Menu',
    openTiming: 'Sun–Thu 11 AM – 2 AM  |  Fri–Sat 11 AM – 3 AM',
    cta: { label: 'view full menu', link: '/menu' },
    tabs: ['APPETIZERS', 'GRILLED ENTREES', 'PASTA & PIZZA', 'DESSERTS'],
    items: [
      {
        id: 1,
        name: 'Blazing Baby Corn',
        price: '$15.00',
        description: 'Crispy baby corn tossed in a fiery blend of signature spices and herbs.',
        badge: 'POPULAR',
        image: 'menu-image-5.png',
      },
      {
        id: 2,
        name: 'Lamb Chops',
        price: '$27.00',
        description: 'Premium lamb chops marinated in Mediterranean spices, grilled to perfection.',
        badge: null,
        image: 'menu-image-6.png',
      },
      {
        id: 3,
        name: 'Chicken Fettuccine Alfredo',
        price: '$16.00',
        description: 'Creamy fettuccine pasta with tender chicken in a rich Alfredo sauce.',
        badge: null,
        image: 'menu-image-7.png',
      },
      {
        id: 4,
        name: 'Beef Tenderloin Kebab',
        price: '$26.00',
        description: 'Five succulent pieces of seasoned beef tenderloin, char-grilled on skewers.',
        badge: 'SIGNATURE',
        image: 'menu-image-8.png',
      },
      {
        id: 5,
        name: 'Chicken Shawarma Pizza',
        price: '$16.00',
        description: 'Artisan pizza topped with seasoned shawarma chicken, pickles & garlic sauce.',
        badge: 'NEW',
        image: 'menu-image-9.png',
      },
      {
        id: 6,
        name: 'Layali Lebanon',
        price: '$9.00',
        description: 'A classic Lebanese semolina pudding topped with cream and crushed pistachios.',
        badge: null,
        image: 'menu-image-10.png',
      },
    ],
  },

  /* ──── Appetizers & Small Bites ──── */
  appetizers: {
    subtitle: 'starter menu',
    title: 'Appetizers & Small Bites',
    items: [
      { id: 1, name: 'Blazing Baby Corn', price: '$15.00', description: 'Crispy baby corn tossed in a fiery blend of signature spices and herbs.', badge: 'POPULAR' },
      { id: 2, name: 'Chicken 65', price: '$15.00', description: 'Classic Indian-style spicy fried chicken bites with curry leaves and chili.', badge: null },
      { id: 3, name: 'Mozzarella Sticks', price: '$10.00', description: 'Six golden-fried mozzarella sticks served with marinara dipping sauce.', badge: null },
      { id: 4, name: 'Lemon Pepper French Fries', price: '$7.00', description: 'Crispy fries seasoned with zesty lemon pepper and fresh herbs.', badge: null },
      { id: 5, name: 'Peri-Peri French Fries', price: '$7.00', description: 'Crispy fries dusted with fiery peri-peri seasoning for a spicy kick.', badge: 'SPICY' },
      { id: 6, name: 'Onion Samosa', price: '$7.00', description: 'Flaky pastry filled with seasoned onions and aromatic spices, deep fried.', badge: null },
      { id: 7, name: 'Chicken Samosa', price: '$8.00', description: 'Crispy golden samosa stuffed with spiced minced chicken and herbs.', badge: null },
      { id: 8, name: 'Beef Samosa', price: '$8.00', description: 'Savory pastry stuffed with seasoned ground beef and Middle Eastern spices.', badge: null },
      { id: 9, name: 'Loaded Fries with Chicken', price: '$13.00', description: 'Crispy fries loaded with seasoned chicken, cheese, jalapenos & sauces.', badge: 'POPULAR' },
      { id: 10, name: 'Loaded Fries with Bolognese', price: '$15.00', description: 'Crispy fries topped with hearty beef bolognese sauce and melted cheese.', badge: null },
      { id: 11, name: 'Bloody Cauliflower', price: '$13.00', description: 'Crispy cauliflower florets tossed in a bold, spicy sauce. Vegetarian.', badge: 'V' },
      { id: 12, name: 'Traditional Wings', price: '$12.00', description: 'Classic chicken wings tossed in your choice of sauce — mild, medium, or hot.', badge: null },
    ],
  },

  /* ──── Soups ──── */
  soups: {
    subtitle: 'warm & comforting',
    title: 'Soups',
    items: [
      { id: 1, name: 'Soup of the Day', price: '$10.00', description: 'Freshly prepared soup made daily with seasonal ingredients. Ask your server.', badge: null },
    ],
  },

  /* ──── Mezze & Cold Plates ──── */
  mezze: {
    subtitle: 'Mediterranean tradition',
    title: 'Mezze & Cold Plates',
    items: [
      { id: 1, name: 'Classic Hummus', price: '$9.00', description: 'Creamy chickpea dip blended with tahini, lemon & garlic. Served with pita.', badge: 'V' },
      { id: 2, name: 'Hummus with Chicken & Pine Nuts', price: '$13.00', description: 'Our classic hummus topped with seasoned chicken and toasted pine nuts.', badge: null },
      { id: 3, name: 'Hummus with Lamb & Pine Nuts', price: '$15.00', description: 'Silky hummus crowned with spiced ground lamb and golden pine nuts.', badge: null },
      { id: 4, name: 'Beetroot Hummus with Salad', price: '$9.00', description: 'Vibrant beetroot-infused hummus paired with a fresh garden side salad.', badge: 'V' },
      { id: 5, name: 'Classic Falafel', price: '$9.00', description: 'Golden-fried chickpea patties with herbs — crispy outside, fluffy inside.', badge: 'V' },
      { id: 6, name: 'Classic Foul', price: '$9.00', description: 'Slow-cooked fava beans seasoned with olive oil, cumin, lemon & garlic.', badge: 'V' },
      { id: 7, name: 'Muhammara', price: '$9.00', description: 'A rich, smoky roasted red pepper and walnut dip with pomegranate molasses.', badge: 'V' },
      { id: 8, name: 'Baba Ghanoush', price: '$9.00', description: 'Smoky fire-roasted eggplant blended with tahini, lemon & garlic.', badge: 'V' },
      { id: 9, name: 'Qalayet Bandora', price: '$16.00', description: 'Sauteed tomatoes with beef or lamb in olive oil, garlic & Middle Eastern spices.', badge: null },
    ],
  },

  /* ──── Signature Platters (For Sharing) ──── */
  signaturePlatters: {
    subtitle: 'feast together',
    title: 'Signature Platters for Sharing',
    items: [
      { id: 1, name: 'Hummus Trio Sampler', price: '$17.00', description: 'Three varieties of our handmade hummus — classic, beetroot & muhammara.', badge: 'V' },
      { id: 2, name: 'House Mezze Sampler', price: '$19.00', description: 'A grand selection of our finest cold mezze plates to share with the table.', badge: 'V' },
      { id: 3, name: "King's Platter", price: '$80.00', description: 'The ultimate feast — lamb chops, mixed kebabs, chicken, rice & all the sides.', badge: 'SIGNATURE' },
      { id: 4, name: 'Mixed Grill Platter', price: '$60.00', description: 'A generous assortment of grilled lamb, chicken & beef kebabs with sides.', badge: null },
      { id: 5, name: 'Red Platter', price: '$70.00', description: 'Premium platter featuring our finest grilled meats and signature sauces.', badge: null },
      { id: 6, name: 'Green Platter', price: '$50.00', description: 'A vibrant vegetarian sharing platter with falafel, hummus, salads & more.', badge: 'V' },
    ],
  },

  /* ──── Salads ──── */
  salads: {
    subtitle: 'fresh & healthy',
    title: 'Salads',
    items: [
      { id: 1, name: 'Fattoush Salad', price: '$12.00', description: 'Classic Levantine salad with crispy pita, mixed greens, tomatoes & sumac dressing.', badge: 'V' },
      { id: 2, name: 'Greek Salad', price: '$12.00', description: 'Tomatoes, cucumbers, red onion, Kalamata olives & creamy feta cheese.', badge: 'V' },
      { id: 3, name: 'Tabbouleh Salad', price: '$12.00', description: 'Fresh parsley, bulgur wheat, tomato, mint & lemon-olive oil dressing.', badge: 'V' },
      { id: 4, name: 'Caesar Salad', price: '$12.00', description: 'Crisp romaine lettuce, Parmesan, croutons & classic Caesar dressing.', badge: null },
    ],
  },

  /* ──── Chef's Specialties ──── */
  chefSpecialties: {
    subtitle: "chef's selection",
    title: "Chef's Specialties",
    items: [
      { id: 1, name: 'Jordanian Lamb Mansef', price: '$24.00', description: 'Tender slow-cooked lamb over seasoned rice with tangy yogurt sauce & pine nuts.', badge: 'SIGNATURE' },
      { id: 2, name: 'Signature Lamb Burger', price: '$18.00', description: 'Juicy lamb patty with Mediterranean toppings on a toasted brioche bun.', badge: null },
      { id: 3, name: 'Lamb Shank', price: '$24.00', description: 'Slow-braised lamb shank falling off the bone, served with aromatic rice.', badge: null },
      { id: 4, name: 'Chicken Shawarma Plate', price: '$13.00', description: 'Seasoned rotisserie chicken carved thin, served with rice, salad & garlic sauce.', badge: 'POPULAR' },
    ],
  },

  /* ──── Signature Grilled Entrees ──── */
  grilledEntrees: {
    subtitle: 'from the grill',
    title: 'Signature Grilled Entrees',
    items: [
      { id: 1, name: 'Grilled Chicken Kebab', price: '$17.00', description: 'Tender marinated chicken pieces grilled on skewers with Mediterranean spices.', badge: null },
      { id: 2, name: 'Lamb Kebab Skewer', price: '$19.00', description: 'Juicy ground lamb blended with onions, parsley & aromatic spices, grilled.', badge: null },
      { id: 3, name: 'Beef Tenderloin Kebab', price: '$26.00', description: 'Five succulent pieces of seasoned beef tenderloin, char-grilled on skewers.', badge: 'SIGNATURE' },
      { id: 4, name: 'Tandoori Chicken Kebab', price: '$17.00', description: 'Marinated in yogurt and tandoori spices, grilled to smoky perfection.', badge: null },
      { id: 5, name: 'Grilled Salmon', price: '$21.00', description: 'Fresh Atlantic salmon fillet grilled with herbs, lemon & extra virgin olive oil.', badge: null },
      { id: 6, name: 'Lamb Chops', price: '$27.00', description: 'Premium lamb chops marinated in Mediterranean herbs and grilled to order.', badge: 'POPULAR' },
      { id: 7, name: 'Falafel Plate', price: '$16.00', description: 'Golden chickpea falafel served with hummus, salad, pickles & warm pita.', badge: 'V' },
      { id: 8, name: 'Grilled Chicken with Creamy Freekeh', price: '$19.00', description: 'Tender grilled chicken breast served over creamy roasted green wheat freekeh.', badge: null },
    ],
  },

  /* ──── Rice Lovers ──── */
  riceDishes: {
    subtitle: 'hearty & filling',
    title: 'Rice Lovers',
    items: [
      { id: 1, name: 'Veg Fried Rice', price: '$13.00', description: 'Wok-tossed basmati rice with fresh seasonal vegetables and aromatic spices.', badge: 'V' },
      { id: 2, name: 'Chicken Fried Rice', price: '$16.00', description: 'Fragrant fried rice loaded with tender chicken pieces and fresh vegetables.', badge: null },
      { id: 3, name: 'Rice Bowl', price: '$16.00', description: 'Your choice of falafel, chicken, or beef over seasoned rice with toppings.', badge: null },
    ],
  },

  /* ──── Pasta ──── */
  pasta: {
    subtitle: 'Italian meets Mediterranean',
    title: 'Pasta',
    items: [
      { id: 1, name: 'Chicken Fettuccine Alfredo', price: '$16.00', description: 'Creamy fettuccine pasta with tender chicken breast in a rich Alfredo sauce.', badge: null },
      { id: 2, name: 'Spaghetti Bolognese', price: '$16.00', description: 'Classic spaghetti with a slow-simmered beef bolognese and Parmesan.', badge: null },
      { id: 3, name: 'Arrabbiata', price: '$14.00', description: 'Penne in a fiery tomato sauce with garlic, chili flakes & fresh basil.', badge: 'V' },
      { id: 4, name: 'Pesto Pasta', price: '$14.00', description: 'Pasta tossed in a fragrant basil pesto with olive oil and Parmesan.', badge: 'V' },
    ],
  },

  /* ──── Artisan Pizzas ──── */
  pizzas: {
    subtitle: 'handcrafted',
    title: 'Artisan Pizzas',
    items: [
      { id: 1, name: 'Chicken Shawarma Pizza', priceMedium: '$14.00', priceLarge: '$16.00', description: 'Shawarma-spiced chicken with pickles, garlic sauce & fresh veggies.', badge: 'POPULAR' },
      { id: 2, name: 'Tandoori Chicken Pizza', priceMedium: '$14.00', priceLarge: '$16.00', description: 'Tandoori-marinated chicken with bell peppers, red onion & cilantro.', badge: null },
      { id: 3, name: 'Beef Pepperoni Pizza', priceMedium: '$17.00', priceLarge: '$19.00', description: 'Loaded with premium beef pepperoni and melted mozzarella cheese.', badge: null },
      { id: 4, name: 'Shrimp Pesto Pizza', priceMedium: '$17.00', priceLarge: '$19.00', description: 'Succulent shrimp on a basil pesto base with mozzarella & cherry tomatoes.', badge: 'NEW' },
      { id: 5, name: 'Vegetarian Pizza', priceMedium: '$12.00', priceLarge: '$14.00', description: 'Fresh bell peppers, mushrooms, olives, onions & tomatoes on mozzarella.', badge: 'V' },
      { id: 6, name: 'Cheese Lovers Pizza', priceMedium: '$10.00', priceLarge: '$12.00', description: 'A blend of premium cheeses on our signature dough — simple and delicious.', badge: null },
    ],
  },

  /* ──── Sides ──── */
  sides: {
    subtitle: 'perfect additions',
    title: 'Sides',
    items: [
      { id: 1, name: 'Basmati Rice', price: '$4.00', badge: 'V' },
      { id: 2, name: 'French Fries', price: '$4.00', badge: 'V' },
      { id: 3, name: 'Bread', price: '$3.00', badge: 'V' },
      { id: 4, name: 'Grilled Chicken Skewer', price: '$8.00', badge: null },
      { id: 5, name: 'Grilled Lamb Kefta', price: '$10.00', badge: null },
      { id: 6, name: 'Mozzarella Sticks', price: '$8.00', badge: 'V' },
      { id: 7, name: 'Falafel (6 pcs)', price: '$8.00', badge: 'V' },
      { id: 8, name: 'Black Olives', price: '$5.00', badge: 'V' },
      { id: 9, name: 'Green Olives', price: '$5.00', badge: 'V' },
      { id: 10, name: 'Mixed Pickles', price: '$2.00', badge: 'V' },
      { id: 11, name: 'Freekeh', price: '$10.00', badge: 'V' },
    ],
  },

  /* ──── Desserts ──── */
  desserts: {
    subtitle: 'sweet endings',
    title: 'Desserts',
    items: [
      { id: 1, name: 'Layali Lebanon', price: '$9.00', description: 'Classic Lebanese semolina pudding topped with cream and crushed pistachios.', badge: null },
      { id: 2, name: 'Mahalabia', price: '$7.00', description: 'Silky Middle Eastern milk pudding with rosewater and ground pistachios.', badge: null },
      { id: 3, name: 'Baklava (3 pcs)', price: '$8.00', description: 'Flaky phyllo pastry layered with nuts and soaked in sweet honey syrup.', badge: 'POPULAR' },
      { id: 4, name: 'Kunafa', price: '$9.00', description: 'Warm shredded pastry filled with sweet cheese, soaked in sugar syrup.', badge: 'SIGNATURE' },
      { id: 5, name: 'Tiramisu', price: '$7.00', description: 'Classic Italian espresso-soaked ladyfingers layered with mascarpone cream.', badge: null },
      { id: 6, name: 'Mango Tiramisu', price: '$8.00', description: 'A tropical twist on tiramisu with fresh mango and mascarpone cream.', badge: 'NEW' },
    ],
  },

  /* ──── Barista Menu ──── */
  barista: {
    subtitle: 'crafted beverages',
    title: 'Barista Menu',
    categories: [
      {
        name: 'Hot Coffee',
        items: [
          { name: 'Espresso', price: '$3.00' },
          { name: 'Double Espresso', price: '$4.00' },
          { name: 'Americano', price: '$4.00' },
          { name: 'Cappuccino', price: '$6.00' },
          { name: 'Latte', price: '$6.00' },
          { name: 'Flat White', price: '$6.00' },
          { name: 'Mocha', price: '$6.00' },
          { name: 'Turkish Coffee', price: '$4.00' },
        ],
      },
      {
        name: 'Iced Coffee',
        items: [
          { name: 'Iced Americano', price: '$4.00' },
          { name: 'Iced Latte', price: '$6.00' },
          { name: 'Iced Mocha', price: '$6.00' },
          { name: 'Iced Caramel Latte', price: '$7.00' },
        ],
      },
      {
        name: 'Specialty Drinks',
        items: [
          { name: 'Hot Chocolate', price: '$6.00' },
          { name: 'White Hot Chocolate', price: '$6.00' },
          { name: 'Matcha Latte', price: '$4.00' },
          { name: 'Tiramisu Latte', price: '$8.00' },
          { name: 'Biscoff Latte', price: '$8.00' },
        ],
      },
      {
        name: 'Tea',
        items: [
          { name: 'Black Tea Pot', price: '$10.00' },
          { name: 'Black Tea Cup', price: '$4.00' },
          { name: 'Green Tea Pot', price: '$10.00' },
          { name: 'Green Tea Cup', price: '$4.00' },
          { name: 'Mint Tea Pot', price: '$10.00' },
          { name: 'Mint Tea Cup', price: '$4.00' },
          { name: 'Masala Chai', price: '$4.00' },
        ],
      },
    ],
  },

  /* ──── Drinks ──── */
  drinks: {
    subtitle: 'refreshments',
    title: 'Drinks',
    categories: [
      {
        name: 'Sodas & Classics',
        items: [
          { name: 'Coca-Cola / Diet Coke / Sprite', price: '$3.00' },
          { name: 'Sparkling Water', price: '$3.00' },
          { name: 'Still Water', price: '$2.00' },
        ],
      },
      {
        name: 'House Specials & Juices',
        items: [
          { name: 'Fresh Lemonade', price: '$5.00' },
          { name: 'Mango Lassi', price: '$6.00' },
          { name: 'Fresh Orange Juice', price: '$6.00' },
          { name: 'Jallab', price: '$5.00' },
        ],
      },
    ],
  },

  /* ──── Hookah ──── */
  hookah: {
    subtitle: 'premium lounge',
    title: 'Hookah Menu',
    pricing: [
      { name: 'Regular Hookah', price: '$19.00' },
      { name: 'Premium Hookah', price: '$25.00' },
      { name: 'Fruit Head Hookah', price: '$30.00' },
    ],
    addons: [
      { name: 'Extra Bowl', price: '$10.00' },
      { name: 'Ice Tip', price: '$2.00' },
      { name: 'Fruit on the Side', price: '$5.00' },
    ],
    flavorBrands: [
      'Al Fakher',
      'Fumari',
      'Starbuzz',
      'Adalya',
      'Mazaya',
      'Trifecta',
      'Azure',
    ],
  },

  /* ──── Alcoholic Beverages ──── */
  alcoholic: {
    subtitle: 'Spirits & more',
    title: 'Alcoholic Beverages',
    categories: [
      {
        name: 'Beer',
        items: [
          { name: 'Corona Extra', price: '$4.00' },   
          { name: 'Dos Equis XXX', price: '$4.00' },
          { name: 'Michelob Ultra', price: '$4.00' },
          { name: 'Blue Moon Belgian White', price: '$4.00' },
          { name: 'Modelo Especial', price: '$4.00' },
          { name: 'Summer Shandy', price: '$4.00' },
          { name: 'Stella Artois', price: '$4.00' },
          { name: 'Bud Light', price: '$4.00' },
          { name: 'Taj Mahal', price: '$7.00' }
        ]
      },
      {
        name: 'Whisky & Scotch',
        items: [
          { name: 'McCallan 12 Year', price: '$25.00' },   
          { name: 'Jack Daniels', price: '$9.00' },
          { name: 'Johnnie Walker Black Label', price: '$12.00' },
          { name: 'GlenLivett 12 Year', price: '$4.00' },
          { name: 'Modelo Especial', price: '$18.00' }
        ]
      },
      {
         name: 'Vodka',
         items: [
            { name: 'Grey Goose', price: '$13.00' },
            { name: 'Tito’s Handmade', price: '$9.00' }
         ] 
      },
      {
        name: 'Tequila',
        items: [
          { name: 'Patron Silver', price: '$12.00' }
        ]
      },
      {
        name: 'Cognac & Brandy',
        items: [
          { name: 'Hennessy VS', price: '$13.00' }
        ]
      }      
    ],
  }
};

export default menuContent;
